import getApolloClient from './apolloClient'
import gql from 'graphql-tag'
import Vue from 'vue'


const way = './graphql/signy/'

export default class SignyApi {
  async getContractInfoByTender( tenderId ) {
    let query = await import( way + 'getContractInfoByTender.gql')
    return (await getApolloClient('/signy'))
      .query({
        query: gql`${query}`,
        variables: { tenderId }
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }
  async loadFile( files ) {
    let query = await import( way + 'loadFile.gql')
    return (await getApolloClient('/signy'))
      .query({
        query: gql`${query}`,
        variables: { files }
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }
}
